import { Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { ConfirmDialogData } from '../confirm-dialog.models';
import { MibButtonDirective } from '../../button';
import { MibIconComponent } from '../../icons';
import { MibDialogInitialFocusDirective } from '../../../directives';

let nextId = 0;

@Component({
  imports: [MibButtonDirective, MibIconComponent, NgTemplateOutlet, MibDialogInitialFocusDirective],
  templateUrl: './confirm-dialog.component.html',
})
export class MibConfirmDialogComponent {
  /** The CDK reference of this dialog, closed with its result. */
  readonly dialogRef = inject<DialogRef<boolean>>(DialogRef);
  /** The payload handed to `dialog.open()` through its `data` option. */
  readonly data = inject<ConfirmDialogData>(DIALOG_DATA);
  /** Whether the payload asked for the dark surface. */
  readonly isDark = this.data.darkMode === true;
  private readonly uid = nextId++;
  protected readonly titleId = `mib-confirm-dialog-title-${this.uid}`;
}
